import { render, staticRenderFns } from "./SettlementsPerPeriod.vue?vue&type=template&id=1fe98d1d&scoped=true"
import script from "./SettlementsPerPeriod.vue?vue&type=script&lang=ts"
export * from "./SettlementsPerPeriod.vue?vue&type=script&lang=ts"
import style0 from "./SettlementsPerPeriod.vue?vue&type=style&index=0&id=1fe98d1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe98d1d",
  null
  
)

export default component.exports